import { render, staticRenderFns } from "./TotalCallsDashboard.vue?vue&type=template&id=7802cd56"
import script from "./TotalCallsDashboard.vue?vue&type=script&lang=js"
export * from "./TotalCallsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports